import React, { createContext, useContext } from 'react';

// AIDEV-NOTE: Portal-based SPA surfaces (SPADialog, SPAPopover) render into document.body, outside
// the `.spa-theme-light` wrapper a legacy mount uses to pin the tokens (see admin/AISafetyReport).
// The scope carries that class to them, so a dialog opened from a light-pinned page is light too.
const SPAThemeScopeContext = createContext<string | undefined>(undefined);

interface SPAThemeScopeProps {
  children: React.ReactNode;
  className: string;
}

export const SPAThemeScope = ({ children, className }: SPAThemeScopeProps) => (
  <SPAThemeScopeContext.Provider value={className}>{children}</SPAThemeScopeContext.Provider>
);

export const useSPAThemeScope = () => useContext(SPAThemeScopeContext);
